
import AppEditRow from "@/components/stock/EditRow.vue";
import AppTable from "@/components/stock/Table.vue";
import { StockIn } from "@/models/base";
import Vue from "vue";

export default Vue.extend({
	props: {
		selectedRow: {
			type: Object as () => StockIn,
		},
		stocks: {
			type: Array as () => StockIn[],
			required: true
		},
		isSaving: Boolean
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		save() {
			this.$emit("save");
		},
		editRow(row:StockIn) {
			this.$emit("edit-row", row);
		},
		addRow(row:StockIn) {
			this.$emit("add-row", row);
		},
		onRemove(row:StockIn) {
			this.$emit("remove-row", row);
		}
	},
	components: {
		AppEditRow,
		AppTable
	}
});
